import React from 'react'
import undefsafe from 'undefsafe'
import classNames from 'classnames'

import SearchFilters from '../../components/filters/searchFilters'
import SearchResultHeaderContainer from './result/searchResultHeaderContainer'
import SearchResultBodyContainer from './result/searchResultBodyContainer'
import SearchNoResults from './result/searchNoResults'
import RelatedSearches from './result/relatedSearches'
import ElementsBanner from '../../components/banners/elementsBanner'
import StudioRecommendationsBanner from '../../components/banners/studioRecommendationsBanner'
import { getFlattenLocation, parseLocation } from '../../../common/utils/urlHelper'
import siteConfig from '../../../common/utils/siteConfig'
import Pagination from '../../components/pagination/pagination'
import CrossPromoBanner from '../../components/banners/crossPromoBanner'

const SearchContentSection = ({
  user,
  baseUrl,
  results,
  location,
  loading,
  currentSite,
  relatedSearches,
  studioRecommendations
}) => {
  const shouldShowRecommendedSearches = !loading && relatedSearches && relatedSearches.recommendations.length > 0
  const totalHits = results.total_hits
  const matches = results.matches
  const aggregations = undefsafe(results, 'aggregations')
  const haveResults = !!(matches && matches.length)
  const shouldShowPagination = totalHits > 0
  const flattenLocation = getFlattenLocation(location)
  const pageSize = siteConfig(currentSite, 'common.search_page_size')
  const maxPagesCount = siteConfig(currentSite, 'common.max_pages_count')
  const parsedLocation = parseLocation(location)
  const currentCategory = parsedLocation.category
  const viewType = undefsafe(user, 'preferences.searchResultsViewType')

  const containerClassNames = classNames('grid-container', {
    '-layout-videohive': currentSite === 'videohive' && viewType === 'grid'
  })

  return (
    <div className={containerClassNames}>
      <aside className='sidebar-s -size-fixed-tablet fds-u-hide-small-and-below'>
        <SearchFilters
          aggregations={aggregations}
          location={flattenLocation}
          currentSite={currentSite}
        />
        <CrossPromoBanner
          currentSite={currentSite}
          currentCategory={currentCategory}
        />
      </aside>
      <div className='content-l -size-scale-tablet content-right'>
        <SearchResultHeaderContainer
          date={undefsafe(aggregations, 'date')}
          location={location}
        />
        { haveResults
          ? <SearchResultBodyContainer
            location={location}
            matches={matches}
          /> : <SearchNoResults location={location} />
        }
        { shouldShowRecommendedSearches &&
          <RelatedSearches {...relatedSearches} />
        }
        { shouldShowPagination &&
          <Pagination
            currentPage={Number(location.query.page) || 1}
            totalItemsCount={totalHits}
            pageSize={pageSize}
            location={location}
            baseUrl={baseUrl}
            maxPagesCount={maxPagesCount}
          />
        }
        { haveResults &&
          <ElementsBanner currentSite={currentSite} />
        }
        { haveResults &&
          <StudioRecommendationsBanner
            config={studioRecommendations}
            currentSite={currentSite}
            category={parsedLocation.category}
            term={parsedLocation.term}
          />
        }
      </div>
    </div>
  )
}

export default SearchContentSection



// WEBPACK FOOTER //
// ./client/pages/search/searchContentSection.js